export var reducerUserName = '@platform/service-user';
